import Auth from '@aws-amplify/auth'
import { navigate } from 'gatsby'
import React, { useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import { useAppState } from '../../appState'
import { ROUTES } from './../../constants'

const PrivateRoute = ({ component: Component, isFromIos, ...rest }) => {
  const [appState] = useAppState()
  const isLoggedIn = appState.userId > 0
  const urlParams = new URLSearchParams(window.location.search)
  const redirectParam = urlParams.get('redirect')
  isFromIos = false

  useEffect(() => {
    const checkAuth = async () => {
      try {
        let auth = await Auth.currentSession()
        const isAuthenticated = auth.isValid()
        if (!isAuthenticated)
          navigate(
            isFromIos ? `/app/join?redirect=${redirectParam}` : ROUTES.signIn
          )
        if (!localStorage.getItem('personalInfoTrigger')) {
          localStorage.removeItem('joinSourceUrl') // remove stale redirection
        }
      } catch (err) {
        navigate(
          isFromIos ? `/app/join?redirect=${redirectParam}` : ROUTES.signIn
        )
      }
    }
    checkAuth()
  }, [])

  return <div>{isLoggedIn && <Component {...rest} />}</div>
}
export default withTranslation()(PrivateRoute)
